<template>
  <div
      class="kyra-fixed-bg"
      :style="{ background: colorArrayToLinearGradient(bgColors, 0) }"
  />
</template>

<script>

import {colorArrayToLinearGradient} from "@/utils/UI";

export default {
  name: 'DefaultBackground',
  props: {},
  data() {
    return {
      pw: null
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    colorArrayToLinearGradient,
  },
  computed: {
    bgColors(){
      const vm = this

      const darkColors = ['#1b1c22', '#1c1d27', '#232429']
      const lightColors = ['#c5c3c3', '#c6c5c5', '#e6e5e5']

      return vm.isDark ? darkColors : lightColors
    }
  }
}
</script>
<style scoped lang="scss">

</style>
